import type { FaireProductEntity } from "../../entity_types/product";

export const p_h4n7cqkgrs: FaireProductEntity = {
  token: "p_h4n7cqkgrs",
  type: "product",
  name: "EMPATH PROTECTION Crystal Infused Natural Perfume Oil with Black Tourmaline",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/45c96573d414d6d5a84e5fb1877758407eccc98f45c09c1fcbd58f934098925f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/412a660c1e52ee8b34860bf12128189edbc4dabe668da5f4ea2649185f367415.jpeg",
    "https://cdn.faire.com/fastly/a357a4e8fdfa9b596bf1660a34666a36b04d4e6356b346403c2aef1d92b286f9.jpeg",
    "https://cdn.faire.com/fastly/28cac06a9163d7bf8b98d9cfcba5408017a3358e002ecee569d63342e49e700b.jpeg",
    "https://cdn.faire.com/fastly/bccaa9de26f79d9d4e2ad73f23435902aa1aec9cdf6cf8eb3b9a24ae22a2798a.jpeg",
    "https://cdn.faire.com/fastly/ea4d1424820ce8ce5f60af15ceeccdbe212bf387e5c7892ee7759b52425381cf.jpeg",
    "https://cdn.faire.com/fastly/805211f056e1e45f38a1f7a5b58dfc29a3f7d78fe722da924e349455632a6b3c.jpeg",
    "https://cdn.faire.com/fastly/f62fb296fc8f860b5d8fb35910f3190107105fc7953b7e772827b4a372defec6.jpeg",
  ],
  priceDollars: 20.5,
  description:
    "Introducing Empath, the botanical perfume oil that provides protection from negative energy. This luxurious oil is crafted with Black Tourmaline crystals, Palo Santo, and Green Sage, and is perfect for Empaths who need a little extra protection against the stresses of daily life.\n\nBlack Tourmaline is known as the pinnacle of protective stones, and is said to deflect negative energy and remove toxins from the body. Palo Santo is a powerful cleansing agent that purifies and protects, while Green Sage promotes wisdom, growth, and understanding. Together, these three ingredients create a truly powerful formula that will keep you feeling safe, grounded, and protected.\n\nEmpath is more than just a perfume oil - it's a protective talisman that will help you navigate the challenges of daily life with ease. Order yours today and see the difference!\n\nIngredients : 1/2 oz glass perfume bottle, fractionated coconut oil, Organic Palo Santo Essential Oil, Organic Green Sage Essential Oil, + Black Tourmaline Crystals.\n",
  tags: [],
  msrpDollars: 41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:06.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
